import {
  type CancelingLazyFetchingItemsState,
  createCancelingLazyFetchingItemsSlice,
} from "features/Application/slices/createCancelingLazyFetchingItemsSlice";
import ReducerNamespaceTypes from "enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "enums/reducer/reducerEntityPrefixTypes";
import { fetchAccountPacksGrid } from "features/Accounts/state/thunks/accountPacksThunk";
import { type AccountPack } from "features/Accounts/types";

export type AccountPacksOverviewState = CancelingLazyFetchingItemsState<AccountPack>;

export const initialState: AccountPacksOverviewState = {
  areAllLoaded: false,
  isLoading: false,
  items: [],
  itemsCount: 0,
  currentRequestId: "",
};

const accountPacksGridSlice = createCancelingLazyFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.AccountPacks,
    name: "gridItems",
  },
  initialState,
  reducers: {},
  thunk: fetchAccountPacksGrid,
});

export const resetAccountPacksGrid = accountPacksGridSlice.actions.reset;

export default accountPacksGridSlice.reducer;
